import Swiper from "swiper";
import { Autoplay } from "swiper";
// Swiper.use([Autoplay, Pagination, EffectFade]);

const forLowerLayerSlide = () => {
  const slideLength = document.querySelectorAll(".swiper-slide").length;

  if (slideLength > 1) {
    const sliders = document.querySelectorAll(".business-slider");
    sliders.forEach((element, index) => {
      let activeSlide;
      let nextSlide;
      let nextSlide2;
      let count = 0;
      var swiper = new Swiper(element, {
        modules: [Autoplay],
        autoplay: {
          delay: 1500,
          disableOnInteraction: false,
        },
        loop: true,
        slidesPerView: "auto",
        centeredSlides: true,
        speed: 1400,
        spaceBetween: 10,
        // on: {
        //   slideChange: (swiper) => {
        //     if(count == 0) {
        //       const activeIndex = swiper.activeIndex;
        //       activeSlide = swiper.slides[activeIndex].querySelector('img');
        //       nextSlide = swiper.slides[activeIndex - 1].querySelector('img');
        //       nextSlide2 = swiper.slides[activeIndex - 2].querySelector('img');
        //       activeSlide.style.transform = "translateX(-7%) scale(1.4)";
        //       nextSlide.style.transform = "translateX(6%) scale(1.4)";
        //       nextSlide2.style.transform = "translateX(20%) scale(1.4)";
        //     } else if(count == 1) {
        //       swiper.slides.forEach((el) => {
        //         el.classList.add('slide-init')
        //       })
        //     } else {
              
        //     }
        //     count++;
        //   },
        // },
      });
    });
  } else {
  }
};

export default forLowerLayerSlide;
